<template>
  <div class="page-errors">
    <TalentHeader
      primary
      hide-controls
    />

    <div class="page-errors__body">
      <ContainerMain>
        <h1 class="body-title">
          {{ t(`error.${status}.title`) }}
        </h1>

        <div class="body-description">
          {{ t(`error.${status}.description`) }}
        </div>

        <a
          href="/"
          class="body-link"
        >
          {{ t('error.to_home') }}
        </a>
      </ContainerMain>
    </div>

    <div class="page-errors__code hide-phone">
      {{ status }}
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { computed } from 'vue'
import ContainerMain from '@/components/common/ContainerMain.vue'
import TalentHeader from '@/components/nav/TalentHeader.vue'

const route = useRoute()
const { t } = useI18n()

const status = computed(() => {
  const allowed = [404, 500, 403]
  return allowed.includes(route.meta.status) ? route.meta.status : 500
})
</script>

<style scoped lang="scss">
$color-light: #45fff4;

.page-errors {
  background-color: var(--color-brand-500);
  height: 100vh;
  overflow: hidden;
  position: relative;
  display: grid;
  grid-template-rows: max-content auto 100px;
  flex-direction: column;

  .page-errors__body {
    padding: var(--space-32) 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    color: var(--color-white);
    position: relative;
    z-index: 2;
    border-top: 1px solid rgb(255 255 255 / 20%);
    border-bottom: 1px solid rgb(255 255 255 / 20%);
    text-align: center;

    .body-title {
      font-size: var(--heading-2);
      font-weight: var(--weight-normal);
      line-height: var(--leading-120);
      margin-top: 0;
      margin-bottom: var(--space-24);
    }

    .body-description {
      font-size: var(--font-size-body-2);
      line-height: var(--leading-170);
      font-weight: var(--weight-normal);
      margin-bottom: var(--space-40);
    }

    .body-link {
      cursor: pointer;
      background-color: var(--color-white);
      display: inline-block;
      color: var(--color-brand-500);
      text-transform: uppercase;
      font-size: var(--font-size-body-2);
      line-height: var(--leading-170);
      font-weight: var(--weight-normal);
      border: 0;
      border-radius: var(--border-radius-4);
      padding: var(--space-20) var(--space-40);
      text-decoration: none;
    }
  }

  .page-errors__code {
    color: $color-light;
    font-size: 515px;
    font-weight: var(--weight-semibold);
    letter-spacing: -40px;
    display: flex;
    justify-content: flex-end;
    position: absolute;
    right: -3%;
    bottom: -25%;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    -moz-text-fill-color: transparent;
    background-image: radial-gradient(circle, rgb(69 255 244 / 60%) 0%, rgb(69 255 244 / 0%) 80%);

    &::before {
      content: "";
      width: 1070px;
      height: 1070px;
      border-radius: 1070px;
      opacity: 0.6;
      background: $color-light;
      filter: blur(150px);
      display: block;
      position: absolute;
      z-index: 1;
      top: -10%;
      right: 0;
    }

    &::after {
      content: "";
      width: 1070px;
      height: 1070px;
      border-radius: 1070px;
      opacity: 0.6;
      background: $color-light;
      filter: blur(150px);
      display: block;
      position: absolute;
      z-index: 1;
      top: 0;
      right: -35%;
    }
  }

  &::after {
    content: "";
    width: 630px;
    height: 630px;
    border-radius: 630px;
    background: $color-light;
    filter: blur(150px);
    position: absolute;
    left: -180px;
    bottom: -460px;
  }

  @include desktop-down {
    grid-template-rows: max-content auto;

    .page-errors__body {
      .body-title {
        font-size: var(--heading-5);
        line-height: var(--leading-120);
        font-weight: var(--weight-medium);
      }
    }

    &::after {
      width: 360px;
      height: 360px;
      left: unset;
      bottom: unset;
      right: -130px;
      top: calc(100% - 85px);
    }
  }
}
</style>
